<template>
    <div class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1383', '成品退货-汇总') }}</div>
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1382', '成品退货-明细') }}</div>
            </div>
        </div>
        <div v-if="actitem=='two'" class="ve-list-page__body">
            <out-two></out-two>
        </div>
        <div v-show="actitem=='one'" style=" display:flex;   background:#fff;line-height:30px;height:40px ;border-bottom:2px solid #389;">
            <div style="min-width:1100px;display:flex;padding-top:3px">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;font-weight:600">{{ $LANG('0138', '新增') }} </span></el-link>
                </div> 
                <el-checkbox border size="small"  @change="selChg"  v-model="v_sel" true-label="Y"  false-label="N"><span style="font-size:12px;color:#389;margin-right:5px">{{ $LANG('0263', '全选') }}</span></el-checkbox>
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in stkCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <el-button type="danger"   icon="iconfont icon-daochu" @click="nextGen" size="mini" style="margin-left:15px;height:30px;margin-top:1px">{{ $LANG('1045', '下推应收单') }}</el-button>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>  
        <div v-show="actitem=='one'" class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="rtnData"
            :columnHiddenOption="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :max-height="subHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cellSelectionOption="{enable: false}"
            v-loading="v_loading"
            :element-loading-text="$LANG('1959', '加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="stk_salertn_main"
            ref="refreq">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div v-show="actitem=='one'" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag  :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in stkCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-select filterable  v-else-if="item.key==='CLNTNO' " v-model="poRow[item.key]"   style="width:100%">
                                <el-row v-for="(item ,index) in clntArr " :key="index">
                                    <el-col :span="9">
                                        <el-option  :label="item.ENAME" :value="item.IDNO"></el-option>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-option  :label="item.CLTYPENM" :value="item.IDNO"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.CLNTNM" :value="item.IDNO"></el-option>
                                    </el-col>
                                </el-row>
                            </el-select>
                            <el-select  v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
 
                <div class="one-div"><span class="oneRow">{{ $LANG('0990', '退货明细') }}</span>
 
                    <el-button :disabled="addBool||saveFlag " @click="inputBtn" type="danger" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid red">
                        <i class="iconfont icon-xiazai" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('1376', '引用成品出库单') }}
                    </el-button>
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    v-loading="t_loading"              
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    style="margin-top:-8px"
                    ref="refdtl"
                    highlight-current-row > 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
                    <el-table-column v-for="(item,index ) in dtlCol.filter(item=>item.thide==='N')" :key="index"
                        :prop="item.key"
                        :fixed="item.key==='RN'"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >   
                                <el-input type="number" size="mini" @input="qtyPrc(scope.row,scope.$index)" :disabled="item.disabled==='Y'" v-if="item.edcss==='number'"  v-model="scope.row[item.key]"  @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" style="width:100%"></el-input>                   
                                <el-input  v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>                                 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template> 
                    </el-table-column>    
                   
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="130">
                        <template slot-scope="scope">
 
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="iconfont icon-shanchu" @click="dtlDel(scope.row,scope.$index )">{{ $LANG('0131', '删除') }}</el-button>
                            <el-button size="mini"  type="text" icon="iconfont icon-chakan-copy" @click="qryStkLog(scope.row  )">{{ $LANG('0311', '库存') }}</el-button>
 
                        </template>
                    </el-table-column>  
                </el-table>
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">            
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600">{{ $LANG('1497', '提示：订单审核后不能再编辑 , 如需编辑请弃审') }}</i>
                    <span style="margin-right:20px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  >{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 选择客户 -->
        <el-dialog :visible.sync="cltWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1668', '选择客户') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <cltInfo  @child-clnt="clntSel"></cltInfo>
            </div>
        </el-dialog>
 
        <!-- 选择商品 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="selPrdWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0993', '选择商品') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <prdInfo  @child-matno="prdSel" v-bind:v_type="sendVal"></prdInfo>
            </div>
        </el-dialog>
        <!-- 物料选择  -->
        <el-dialog  :visible.sync="matWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0866', '物料选择') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <matSel @child-matno="matSure" v-bind:v_type="sendVal" ></matSel>
            </div>
        </el-dialog>
 
        <!-- 查看库存 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="logWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0009', '库存日志') }}</span>
            </div> 
            <div style="height:91vh;overflow-y:auto"><stklog v-bind:toolFlag="toolFlag"  v-bind:v_cond="qryCond"></stklog></div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag  v-if="btnWin" :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
   
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import cltInfo from '../datamgt/cust_tmpl.vue'
import prdInfo from '../datamgt/production.vue'
import outTwo from './stk_rtn_two.vue'
import matSel from '../datamgt/material.vue' 
import pubWin from '../datamgt/pubmulti.vue' 
import stklog from './prd_stklog.vue'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'stk_saleRTN',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '122',
            fieldIdseq: '122',
            fieldLstseq: '1',
            mainColumnKey: 'stkCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            columnHiddenOptionKey: 'columnHiddenOption',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            sendVal:'PRD',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            toolFlag:false,
            qryCond:'',
            logWin:false,
            dtlRow:{},
            ordWin:false,
            v_sel:'N',
            cltWin:false,
            selPrdWin:false,
            v_row:{},
            promptWin:false,
            dtlFlag:'create',
            ordCol:[],
            t_loading:false,
            addFlag:'create',
            actitem:'one',
            rowDtl:{},
  
 
            delDtlArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            ruleValidate:{},
            dtlValidate:{'MATNO':[{ required: true, message: this.$LANG('1707', '请输入产品编码'), trigger: 'blur' }],
                        'ACTQTY':[{ required: true, message: this.$LANG('0989', '退货数量'), trigger: 'blur' }]},
            selparam:'IDNO',
            txtparam:'',
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            rtnData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径   
            clntArr:[],
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
                } ],
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            stkCol:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
            },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            colory:'#959997', //审核颜色
            colorx:'#e00e66', //作废颜色
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            matWin:false,
            comboArr:[],
            taxArr:[],
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
        }
    },
    components: {
      cltInfo,  //注册组件
      prdInfo,  //产品列表
      matSel,
      stklog,
      pubWin,
      outTwo,
      VeColumnConfigDialog,
      // JSX query headers are resolved at runtime.
      // eslint-disable-next-line vue/no-unused-components
      VeTableQueryHeader,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 192) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 310) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth- 140) + 'px';
        },
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        //客户
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_bs_clnt','').then(res=>{
            this.clntArr =res.result
        });
        //税率
        getBaseData(this.v_url,'parentno','249' ,'','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','122','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','122','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.stfgChange() //  
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        selChg(){
            if (this.v_sel =='Y'){
                this.rtnData.filter(item=>item.STFG=='Y').filter(item=>!item['ARNO']).forEach((item,index)=>{
                    item['SEL'] ='Y' 
                })
            }else{
                this.rtnData.filter(item=>item.STFG=='Y').forEach((item,index)=>{
                    item['SEL'] ='N' 
                })
            }            
        },
        nextGen(){
            const v_len =this.rtnData.filter(item=>item['SEL']=='Y').length
            if (v_len ==0){
                this.promptWin =true
                this.prompt =this.$LANG('1774', '请选择要下推的记录')
            }else{
                this.$confirm( this.$LANG('1615', '你确定要下推生成退货应收单吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    
                    let v_idseqArr =this.rtnData.filter(item=>item['SEL']=='Y').map(item=>Object.assign({IDSEQ:item.IDSEQ}))
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/mrp_Calc',
                        data: {p_json:JSON.stringify(v_idseqArr), corpid:this.v_corpid, p_action:'RETURN' },
                    }).then(res=>{ 
                        if (res.code=='200'){        
                            this.$notify({
                                title: this.$LANG('1441', '成功'),
                                message: this.$LANG('1492', '已成功下推退货应收单，请到销售应收单界面中查看') ,
                                type: 'success'
                            })
                            this.getRtnList('') 
                        }else{
                            this.promptWin =true
                            this.prompt =this.$LANG('1446', '下推失败！')+res.result
                        }
                    })
    
                }).catch(err=>{})
            }
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getRtnList('')
        } ,
        itemClick(val){
            this.actitem =val     
        },
        //销售订单选择
        btnSure(data_){
            if (data_.length>0){ // 
                for(let k=0;k<data_.length;k++){
                    let v_bool =true
                    this.dtlData.some(item=>{
                        if (item['REFIDSEQ']==data_[k].IDSEQ && item['REFLSTSEQ']==data_[k].LSTSEQ){
                            v_bool =false
                        }
                    })
                    if (v_bool){
                        let obj_={}
                        Object.assign(obj_,{MATNO:data_[k].MATNO,MATNM:data_[k].MATNM,MATDESC:data_[k].MATDESC,RTN_ORDNO:data_[k].CLTORDNO,LSTSEQ:'',RTN_CLNTNM:data_[k].ORDCLNTNM,STKNO:data_[k].STKNO,
                                            UNITNM:data_[k].UNITNM, STKNM:data_[k].STKNM,MATTYNM:data_[k].MATTYNM,POQTY:data_[k].ACTQTY, REFIDNO:data_[k].IDNO,REFIDSEQ:data_[k].IDSEQ,
                                            REFLSTSEQ:data_[k].LSTSEQ,TAXPRC:data_[k].PRC,RTN_IDNO:data_[k].REFIDNO })
                        this.dtlData.push(obj_)
                    }
                }   
            }
            this.btnWin=false
        },
        //查看库存
        qryStkLog(row){
            this.logWin=true
            this.qryCond=' and matno=\''+row.MATNO+'\''
        },
        qtyPrc(row,index){
            if(row['ACTQTY'] && row['TAXPRC']){
                row['AMT']=(Number(row['ACTQTY'])*Number(row['TAXPRC'])).toFixed(2) // *(100+Number(tax))/100
            }else{
                row['AMT']=0
            }
        },
 
        inputBtn(){
            this.v_table ='V_IC_STKDTL_SALEOUT'
            this.tableCol =this.ordCol
            this.v_key2 ='stfg'
            this.v_value2 ='Y'
            this.btnWin =true
        },
        //客户选择
        orgChoose(){
            this.cltWin=true
        },
 
        //退货明细 
        getDtlList(idseq ){
            this.dtlData=[]
            this.t_loading=true
            getTabColOrData(this.v_url,'V_IC_STKDTL_QRY','idseq',idseq,'','','','','' ).then((res) => { 
                this.dtlData =res.result 
                this.t_loading =false
            })
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refdtl.doLayout()
                
            }) 
        },
        //选择产品
        prdChoose(){
            if(this.dtlRow['MATTY']==='PRD'){
                this.selPrdWin=true
            }else{
                this.matWin=true
            }
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'122',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        prdSel(matno,matnm,mattynm,modelnm,matdesc){
            this.dtlRow['MATNO']=matno
            this.dtlRow['MATNM']=matnm
            this.dtlRow['MATTYNM']=mattynm
            this.dtlRow['MODELNM']=modelnm
            this.dtlRow['MATDESC']=matdesc
            this.selPrdWin=false
        },
        matSure(matno,matnm,matdesc,unit,prc){
            this.dtlRow['MATNO']=matno
            this.dtlRow['MATNM']=matnm
            this.dtlRow['MATDESC']=matdesc
            this.dtlRow['UNITNM']=unit
            this.matWin=false
        },
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
 
        //子件供应商选择
        sup_Selrec(){
            this.cltWin=true
        },
        clntSel(idseq,val){
            this.poRow['CLNTNO']=idseq
            this.poRow['CLNTNM']=val
            this.cltWin=false
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            //退货明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true      
        },
        //保存记录
        saveRec(){
            //发起保存请求   
            this.$refs['dtlform'].validate((valid) => {
                if (valid) {         
                    let amt_=0 ,v_bool=false
                    //汇总明细金额
                    if(this.dtlData.length>0){
                        for(let k=0;k<this.dtlData.length;k++){
                            if(this.dtlData[k]['AMT']){
                                amt_=Number(amt_)+Number(this.dtlData[k]['AMT'])
                            }
                            if (!this.dtlData[k]['ACTQTY']){
                                v_bool=true
                            }
                        }
                    }
                    if (v_bool){
                        this.promptWin =true
                        this.prompt =this.$LANG('0108', '明细记录')+this.$LANG('0989', '退货数量')+this.$LANG('2051', '不能为空')
                    }else{
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid,AMT:amt_.toFixed(2)})), p_table:'IC_STK',frmid:'122'},
                        }).then(res=>{      
                            if(res.result ==='OK')  {  
                                let idseq_ =res.idseq
                                //1、退货明细保存：批量保存   
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.dtlData), p_table:'IC_STKDTL',p_idseq:idseq_ , p_action:'S' },
                                }).then(res=>{
                                    if (res.code!=='200'){
                                        this.promtWin=true
                                        this.prompt=res.result
                                    }else{
                                        this.stfgChange()
                                    }
                                })
                                //退货明细删除
                                for (let k=0;k<this.delDtlArr.length;k++) {
                                    this.$axios({   
                                        method: 'post',
                                        url:'xuper_auth/delTabRec',
                                        data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'IC_STKdtl', p_action:'D' },
                                    })
                                } 
            
                                this.addWin =false   
                                
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }
                }
            })
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={ICDTTM:getDate('day'),'IDSEQ':'',IDTY:'SALERTN',STAFFNM:this.v_usernm }
            this.dtlData=[]
            this.saveFlag=false
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        //状态变更
        stfgRec(row,val,index){
            let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
            if (val==='Y'){
                    v_comm=this.$LANG('0134', '审核')
            }else if (val==='N'){
                    v_comm=this.$LANG('2005', '未审核')
            }else if (val==='X'){
                    v_comm=this.$LANG('0257', '作废')
            }
            if (val=='Y'){
                v_chkuser =this.v_usernm
                v_chkdttm=getDate('full')
                v_cond =' set stfg=\''+val+'\' ,chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null'
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'IC_STK',p_cond:v_cond },
                }).then(res=>{      
                    if(res.code =='200')  {   
                        if (val =='X'){
                            this.rtnData.splice(index,1)
                        }else{     
                            Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                        }
                    }else{
                        const errorMsg =res.result
                        const startIndex = errorMsg.indexOf("ORA-20001:") 
                        const endIndex = errorMsg.indexOf("请核查") +3
                        const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                        if (startIndex>0){
                            this.prompt =extractedValue
                        }else{
                            this.prompt =res.result
                        }
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        stfgChange(){
            const toolbarCondition =this.oper === '!=' && isVeTableMetadataField(this.initCol, this.selparam)
                ? ` and ${this.selparam} is null `
                : buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, {
                typeOverrides: { STFG: 'select', SEL: 'checkbox' },
                numberOperatorDefault: '>=',
            })
            this.current =1
            this.getRtnList(toolbarCondition+headerCondition)
        }, 
        sortHeaderColumn(column){
            const key =column && column.key
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) {
                this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            }else{
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            this.stfgChange()
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.rtnData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.rtnData = this.allList          
            }else{
               
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.rtnData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //退货单 
        getRtnList(cond){
            const requestId =++this.queryRequestId
            this.v_loading =true
            const orderField =isVeTableMetadataField(this.initCol, this.headerSortKey)
                ? this.headerSortKey
                : (isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'IDNO')
            const orderDirection =this.headerSortKey ? this.headerSortOrder : 'desc'
            getTabColOrData(this.v_url,'V_IC_STK_SALERTN','IDTY','SALERTN','CORPID',this.v_corpid,'','',`${cond} order by ${orderField} ${orderDirection}`).then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList =res.result || []
                this.initPage() 
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.prompt =error.message || this.$LANG('1641', '查询失败')
                this.promptWin =true
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.v_loading =false
            })
        },
 
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','122','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    vm.stkCol = []
                    vm.vueCol = []
                    vm.sortFieldRows(vm.initCol).forEach(rowField => {
                        const itcol = rowField
                        const title = vm.$translate.getColTitle(itcol, vm.$store.state.lang)
                        vm.stkCol.push({
                            title,
                            key: itcol.key,
                            align: itcol.align,
                            width: itcol.width,
                            thide: itcol.THIDE,
                            fhide: itcol.FHIDE,
                            edcss: itcol.EDCSS,
                            disabled: itcol.DISABLED,
                            dotnum: itcol.DOTNUM,
                            sortable: itcol.SORTABLE,
                        })
                        if (itcol.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: itcol.key,
                            key: itcol.key,
                            title,
                            align: itcol.align,
                            width: Number(itcol.width) || 120,
                            thide: itcol.THIDE,
                            fhide: itcol.FHIDE,
                            sortable: false,
                            renderHeaderCell: ({column}) => <VeTableQueryHeader
                                title={column.title}
                                edcss={itcol.key === 'STFG' ? 'select' : itcol.EDCSS}
                                value={this.v_row[itcol.key]}
                                operator={this.v_row[`#OPER${itcol.key}`]}
                                defaultOperator=">="
                                showDateOperator={false}
                                sortable={itcol.key !== 'RN' && itcol.key !== 'SEL' && itcol.SORTABLE === 'N' && itcol.EDCSS !== 'checkbox'}
                                sortOrder={this.headerSortKey === itcol.key ? this.headerSortOrder : ''}
                                options={itcol.key === 'STFG' ? [
                                    { value: 'N', label: this.$LANG('2005', '未审核') },
                                    { value: 'Y', label: this.$LANG('1976', '已审核') },
                                ] : (['select', 'checkbox'].includes(String(itcol.EDCSS || '').toLowerCase()) ? (this.comboArr[itcol.key] || []) : [])}
                                on-input={(value) => this.$set(this.v_row, itcol.key, value)}
                                on-operator-change={(value) => this.$set(this.v_row, `#OPER${itcol.key}`, value)}
                                on-title-click={() => this.sortHeaderColumn(column)}
                                on-query={this.stfgChange}
                            />,
                            ellipsis: { showTitle: true },
                            renderBodyCell: ({row}) => {
                                const rowVal = row[itcol.key]
                                if (itcol.key === 'IDNO') {
                                    return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{rowVal}</div></el-link>
                                }
                                if (itcol.key === 'SEL') {
                                    return <el-checkbox disabled={!!row.ARNO || row.STFG === 'N'} true-label="Y" false-label="N" v-model={row[itcol.key]} style="width:100%">&nbsp;</el-checkbox>
                                }
                                if (itcol.key === 'STFG') {
                                    return rowVal === 'Y'
                                        ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag>
                                        : <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag>
                                }
                                return <span>{rowVal}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => (
                            <div class="stk-salertn-sequence-header">
                                <div class="stk-salertn-sequence-header__title">{column.title}</div>
                                <el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px">
                                    <el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip>
                                </el-link>
                            </div>
                        ),
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '状态操作'),
                        width: 200,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                <el-link on-click={() => this.editRec(row, 'Y')} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('0139', '查看')}</span></el-link>
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N')} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('0134', '审核')}</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'X', rowIndex)} underline={false}><span style="font-size:12px;margin-right:2px">{this.$LANG('0257', '作废')}</span></el-link>
                                </span> : null}
                                {row.STFG === 'Y' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('0137', '弃审')}</span></el-link>
                                </span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','122','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','122','lstseq','3','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .ve-list-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
    .ve-list-page__table {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ve-list-page__table > .vue-table-root {
        height: 100%;
    }
    .ve-list-page__table /deep/ .ve-table,
    .ve-list-page__table /deep/ .ve-table-container {
        height: 100% !important;
        max-height: 100% !important;
    }
    .ve-list-page__pagination {
        flex: 0 0 38px;
        min-height: 38px;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        background: white;
        font-size: 12px;
        padding-top: 3px;
        box-sizing: border-box;
    }

    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        height:20px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
